module.exports = __webpack_public_path__ + "static/media/cat1.389a90c4.jpg";